import userAPI, { USER_END_POINT } from 'src/api/user';

import { useRequest } from '@helpers/use';
import { useProfile } from '@hooks/useProfile';
import { IWishlist } from '@interfaces/course';

export const useCourseWishlist = (courseId: number) => {
  const { profile } = useProfile();
  const { data: wishlist, isLoading: wishlistLoading, isValidating } = useRequest<IWishlist>(
    profile ? USER_END_POINT.USER_ME_WISHLIST_COURSES : null,
    () => userAPI.fetchUserCourseWishlist(courseId),
  );

  return { wishlist, isValidating, wishlistLoading };
};
